import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import {
  BathroomConfigurationState,
  SelectedElement,
  UISelectionState,
} from 'src/app/models/configurators-2d/mobile/bathroom/bathroom-validation.models';
import { BathroomConfigurationService } from 'src/app/services/configurators-2d/mobile/bathroom/bathroom-configuration.service';
import { captureBathroomPreviewElement } from 'src/app/services/configurators-2d/mobile/bathroom/bathroom-preview-capture.util';

@Component({
  selector: 'ng-casto-bathroom-configuration-preview',
  templateUrl: './bathroom-configuration-preview.component.html',
  styleUrls: ['./bathroom-configuration-preview.component.scss'],
})
export class BathroomConfigurationPreviewComponent implements AfterViewInit, OnDestroy {
  private readonly configurationService = inject(BathroomConfigurationService);
  private readonly subscriptions: Subscription[] = [];
  private unregisterVisiblePreviewCapture: (() => void) | null = null;

  @ViewChild('previewCapture') private previewCapture!: ElementRef<HTMLDivElement>;

  protected configuration: BathroomConfigurationState | null = null;
  protected uiSelection: UISelectionState | null = null;

  constructor() {
    this.subscriptions.push(
      combineLatest([this.configurationService.configuration$, this.configurationService.uiSelection$]).subscribe(
        ([configuration, uiSelection]) => {
          this.configuration = configuration;
          this.uiSelection = uiSelection;
        }
      )
    );
  }

  ngAfterViewInit(): void {
    this.unregisterVisiblePreviewCapture = this.configurationService.registerVisiblePreviewCapture(() =>
      this.captureVisiblePreview()
    );
  }

  ngOnDestroy(): void {
    this.unregisterVisiblePreviewCapture?.();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  protected onElementClick(element: SelectedElement): void {
    this.configurationService.selectElement(element);

    if (element.type === 'column' || element.type === 'cover') {
      this.configurationService.setActiveSection('finitions');
    } else if (element.type === 'basin') {
      this.configurationService.setActiveSection('basin');
    } else if (element.type === 'handle') {
      this.configurationService.setActiveSection('handles');
    }
  }

  private async captureVisiblePreview(): Promise<string | null> {
    if (!this.previewCapture?.nativeElement || !this.configuration?.composition) return null;

    return await captureBathroomPreviewElement(
      this.previewCapture.nativeElement,
      'Erreur lors de la capture de la preview salle de bain'
    );
  }
}
